// extracted by mini-css-extract-plugin
export default {"avatar":"PeopleFilterDropdown_avatar__F+uA+"};